import React from 'react';
import "./styles.scss";

function ImageGridSplit() {
  return (<div className="image-grid__splitted">
    <div><p>Here we will have a splitted image grid. </p>
      <p>Change the name if you do not like the current one.</p></div>
  </div>);
}

export default React.memo(ImageGridSplit);